import { render, staticRenderFns } from "./confirmation-upload-view.vue?vue&type=template&id=bb5cb8ae&scoped=true"
import script from "./confirmation-upload-view.vue?vue&type=script&lang=js"
export * from "./confirmation-upload-view.vue?vue&type=script&lang=js"
import style0 from "./confirmation-upload-view.vue?vue&type=style&index=0&id=bb5cb8ae&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5cb8ae",
  null
  
)

export default component.exports